import React from 'react';
import '../../styles/SolucionesPublicitarias.css';

const BehealthLive = () => {
    return (
        <section className="behealth-live-section pt-5">
            <div className="container">
                <div className='row align-items-end'>
                    <div className='col-md-7'>
                        <img src="assets/live-1.png" alt="logo behealth live" className='img-fluid img-filter' data-aos="flip-right"/>
                        <p className='mt-4' data-aos="fade-up">
                            BeHealth Live permite que las marcas aborden temas de salud a través de transmisiones en vivo, 
                            creando un vínculo directo con audiencias interesadas. Con contenido educativo y speakers reconocidos, 
                            aseguramos máxima visibilidad y relevancia.
                        </p>
                        <p className='mt-4' data-aos="fade-up">
                            <span>
                            En simultáneo, amplificamos tu mensaje con una promoción estratégica que incluye la presencia destacada 
                            de tu marca en eBlast (nuestro newsletter), portadas de eventos y menciones en contenidos en la web. 
                            Los videos se alojarán en YouTube y estarán linkeados desde la web de BeHealth, asegurando un mayor alcance 
                            y visibilidad.</span>
                        </p>
                    </div>
                    <div className='col-md-5' data-aos="flip-right" data-aos-delay="600">
                        <img src="assets/live-2.png" alt="marilina torres y lily garcia" className='img-fluid img-filter' />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default BehealthLive;